<template>
    <div class="panel__container">
        <header class="panel__header">
            <h2 class="panel__title">Invoices</h2>
        </header>

        <table class="table">
            <thead>
                <th>Date</th>
                <th>Amount</th>
                <th></th>
            </thead>
            <tbody>
                <tr :key="invoice.id" v-for="invoice in invoices">
                    <td>{{ invoice.date }}</td>
                    <td>{{ invoice.total }}</td>
                    <td><a :href="invoice.download_url">Download</a></td>
                </tr>
            </tbody>
        </table>

    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState('tenant', ['invoices'])
    }
}

</script>
